function fallbackCopyToClipboard(text: string, callback?: () => void): void {
    const fakeInput = document.createElement('input');
    document.body.appendChild(fakeInput);
    fakeInput.setAttribute('readonly', 'true');
    fakeInput.setAttribute('value', text);
    fakeInput.select();
    // added navigator function below because execCommand is deprecated
    // it is still compatible for now though https://developer.mozilla.org/en-US/docs/web/api/document/execcommand#browser_compatibility
    document.execCommand('copy');
    document.body.removeChild(fakeInput);

    typeof callback === 'function' && callback();
}

export function copyToClipboard(text: string, callback?: () => void): void {
    if (!navigator.clipboard) {
        // keeping fallback because `navigator.clipboard` won't work on safari mobile unless we add gesture handlers, add todo?
        // https://caniuse.com/?search=navigator.clipboard
        fallbackCopyToClipboard(text, callback);
        return;
    }
    navigator.clipboard
        .writeText(text)
        .then(() => {
            callback?.();
        })
        .catch((e) => {
            // eslint-disable-next-line no-console
            console.error(`e: ${e}`);
        });
}
